// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"15":"css/tailwind","97":"css/cpg","252":"css/app","559":"css/tailwind_app"}[chunkId] + ".css";
};